// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"catalogue_breadcrumbs__dDo8I","printHeader":"catalogue_printHeader__THsZk"};